<template>
  <div class="row-nav">
    <div class="main-width">
      <div id="row-nav-navbar">
        <ul class="list-basic-settings pull-right">
          <template v-if=" type=='home' ">
            <li><a href="home.html" class="row-nav-a">首页</a> &nbsp;&nbsp;|&nbsp;&nbsp;</li>
          </template>
          <template v-else>
            <li><a href="cashome.html" class="row-nav-a">首页</a> &nbsp;&nbsp;|&nbsp;&nbsp;</li>
          </template>
          <li><a :href="enterWorkbench" class="row-nav-a">工作中心</a>&nbsp;&nbsp;|&nbsp;&nbsp;</li>
          <li class="home-li-a"><a :href="apiLinks.selfHome" target="_blank" class="row-nav-a">返回官网</a></li>
          <li class="cashome-li-a"><a :href="apiLinks.selfHome" target="_blank" class="row-nav-a">返回官网</a>&nbsp;&nbsp;|&nbsp;&nbsp;</li>
          <li class="cashome-li-a"><a :href="caslogout" class="row-nav-a">退出</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import {apiLinks} from '../api/links'
  export default {
    name: 'gheader',
    props: {
      type: ''
    },
    data () {
      return {
        southCement: apiLinks.southCement['home'],
        enterWorkbench: apiLinks.enterWorkbench,
        caslogout: apiLinks.caslogout,
        apiLinks: apiLinks
      }
    }
  }
</script>

<style>
  /*导航栏*/
  .row-nav {
    height: 44px;
    background-color: #f8f8f8;
    border-bottom: 1px solid #f6f3f3;
  }

  #row-nav-navbar {
    position: relative;
    top: 10px;
    margin-right: 20px;
  }

  .row-nav-a {
    color: #666666;
    font-size: 13px;
  }

  .row-nav-a:hover {
    text-decoration: none;
    padding-bottom: 5px;
    border-bottom: 1px solid #1983D7;
    color: #1983D7;
  }

  .cashome-li-a {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// G-header.vue?337b7874